<template>
  <component
    :is="isExternal ? 'a' : 'router-link'"
    class="link"
    :to="link.url"
    :href="link.url"
    :target="link.targetIsBlank ? '_blank' : ''"
    :rel="link.noFollow ? 'nofollow' : ''"
    v-bind="$attrs">
    <Icon v-if="icon" :name="icon" />
    <template v-if="$slots.default">
      <slot />
    </template>
    <span v-else>{{ link.text }}</span>
  </component>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';

import { Link } from '@/model/content';

export default defineComponent({
  props: {
    link: {
      type: Object as PropType<Link>,
      required: true,
    },
    icon: {
      type: String,
    },
  },
  setup(props) {
    const isExternal = computed(() => props.link.url.includes('http'));

    return {
      isExternal,
    };
  },
});
</script>

<style lang="scss" scoped>
.link {
  color: $dark-grey;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: 0.25s ease-out;

  &:hover {
    color: black;
  }

  :deep(svg) {
    color: black;
    width: 36px;
    min-width: 36px;
    height: 36px;
  }
}
</style>
